import { render } from "./Datenschutztext2.vue?vue&type=template&id=5a89de47"
import script from "./Datenschutztext2.vue?vue&type=script&lang=js"
export * from "./Datenschutztext2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\stfg.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__